import { useMemo } from 'react';
import { useTranscriptions, type TextStreamData } from '@livekit/components-react';
import {
  TRANSCRIPTION_FINAL_ATTRIBUTE,
  TRANSCRIPTION_SEGMENT_ID_ATTRIBUTE,
} from '@shared/constants/livekit.constants';

export interface TranscriptionStreamSegment {
  id: string;
  identity: string;
  text: string;
  timestamp: number;
  isFinal: boolean;
}

export const toTranscriptionSegments = (streams: TextStreamData[]): TranscriptionStreamSegment[] =>
  streams
    .map(({ text, participantInfo, streamInfo }) => ({
      id: streamInfo.attributes?.[TRANSCRIPTION_SEGMENT_ID_ATTRIBUTE] || streamInfo.id,
      identity: participantInfo.identity,
      text,
      timestamp: streamInfo.timestamp,
      isFinal: streamInfo.attributes?.[TRANSCRIPTION_FINAL_ATTRIBUTE] === 'true',
    }))
    .sort((left, right) => left.timestamp - right.timestamp);

export const useTranscriptionStreams = (): TranscriptionStreamSegment[] => {
  const streams = useTranscriptions();

  return useMemo(() => toTranscriptionSegments(streams), [streams]);
};
